import React, { useState, useRef } from "react";
import NewsData from "../data/News-Data";

const Accordion = () => {
   const posts = NewsData;
   const [activeIndex, setActiveIndex] = useState(null);
   const accordionRef = useRef(null); // Ref 생성

   const toggleAccordion = (index) => {
      if (activeIndex === index) {
         setActiveIndex(null);
      } else {
         setActiveIndex(index);

         // 아코디언이 열릴 때 해당 아코디언의 상단으로 스크롤 이동
         if (accordionRef.current) {
            accordionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
         }
      }
   };

   return (
      <div className='Accordion mb100'>
         {posts.map((post, index) => (
            <div key={index} ref={activeIndex === index ? accordionRef : null} className={`accordion-item ${activeIndex === index ? "active" : ""}`}>
               <h1 onClick={() => toggleAccordion(index)}>
                  <img src={post.imgUrl1} alt="" />
                  {post.title}
                  <span>{activeIndex === index ? "─" : "┼"}</span>
               </h1>
               <span>{post.date}</span>
               {activeIndex === index && (
                  <div>
                     <img src={post.imgUrl1} alt="" />
                     <p style={{ fontWeight: 'bold' }}>{post.content1}</p>
                     <p>{post.content2}</p>
                     <img src={post.imgUrl2} alt="" />
                     <p className="mb50">{post.content3}</p>
                     <span>{post.span1}</span>
                     <span>{post.span2}</span>
                     <span className="mb150">{post.span3}</span>
                  </div>
               )}
            </div>
         ))}
      </div>
   );
};

export default Accordion;
